import type { ColumnsType } from 'antd/es/table'
import Ribbon from '../../../types/api/ribbon'
import EditRibbon from '../components/edit-ribbon/edit-ribbon'

export function getRibbonsColumns(onSuccess: () => void): ColumnsType<Ribbon> {
    return [
        {
            title: 'Номер',
            dataIndex: 'id',
            width: 90,
        },
        {
            title: 'Клиент',
            key: 'client',
            render: (_, record) => record.order_item?.order?.client?.name || '—',
        },
        {
            title: 'Рулонов',
            key: 'rollsCount',
            render: (_, record) => record.specs?.rollsCount ?? '—',
        },
        {
            title: 'Отпускная цена',
            key: 'sellPrice',
            render: (_, record) => record.cost?.sellPrice ?? '—',
        },
        {
            title: 'Цена',
            key: 'totalPrice',
            render: (_, record) => {
                const sellPrice = record.cost?.sellPrice
                const rollsCount = record.specs?.rollsCount
                if (sellPrice == null || rollsCount == null) return '—'
                return Math.round(sellPrice * rollsCount * 100) / 100
            },
        },
        {
            title: 'Себестоимость рулона',
            key: 'costPrice',
            render: (_, record) => record.cost?.costPrice ?? '—',
        },
        {
            title: 'Себестоимость',
            key: 'totalCost',
            render: (_, record) => record.specs?.totalCost ?? '—',
        },
        {
            title: 'Прибыль с рулона',
            key: 'profit',
            render: (_, record) => record.specs?.profit ?? '—',
        },
        {
            title: 'Прибыль',
            key: 'totalProfit',
            render: (_, record) => record.specs?.totalProfit ?? '—',
        },
        {
            title: '',
            key: 'actions',
            width: 60,
            fixed: 'right',
            render: (_, record) => <EditRibbon ribbon={record} onSuccess={onSuccess} />,
        },
    ]
}
